const initialState = { formData: {} }

export default (state = initialState, action) => {
  if (action.type === 'SAVE_FORM_DATA') {
    return { ...state, formData: action.formData }
  } else {
    return state
  }
}
